import _objectSpread from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

var HttpClient =
/*#__PURE__*/
function () {
  function HttpClient() {
    _classCallCheck(this, HttpClient);
  }

  _createClass(HttpClient, [{
    key: "post",
    value: function post(url, options) {
      return new _Promise(function (resolve, reject) {
        try {
          var newOptions = _objectSpread({
            method: "post"
          }, options);

          console.info("HttpClient POST:", newOptions);
          cordova.plugin.http.sendRequest(url, newOptions, function (response) {
            // prints 200
            resolve(response);
          }, function (error) {
            // prints 403
            reject(error);
          });
        } catch (error) {
          reject(error);
        }
      });
    }
  }, {
    key: "get",
    value: function get(url, options) {
      return new _Promise(function (resolve, reject) {
        try {
          var newOptions = _objectSpread({
            method: "get"
          }, options); // console.info("HttpClient GET:", newOptions,url);


          cordova.plugin.http.sendRequest(url, newOptions, function (response) {
            // prints 200
            resolve(response);
          }, function (error) {
            // prints 403
            reject(error);
          });
        } catch (error) {
          reject(error);
        }
      });
    }
  }, {
    key: "upload",
    value: function upload(url, options) {
      return new _Promise(function (resolve, reject) {
        try {
          var newOptions = _objectSpread({
            method: "upload"
          }, options); // console.info("HttpClient GET:", newOptions,url);


          cordova.plugin.http.sendRequest(url, newOptions, function (response) {
            // prints 200
            resolve(response);
          }, function (error) {
            // prints 403
            reject(error);
          });
        } catch (error) {
          reject(error);
        }
      });
    }
  }]);

  return HttpClient;
}();

export default new HttpClient();